// components/FAQAccordion.jsx
import React, { useState } from 'react';
import './FAQAccordion.css';

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setOpen(!open)}>
        {question}
        <span className="arrow">{open ? '▲' : '▼'}</span>
      </button>
      {open && <div className="faq-answer">{answer.split('\n').map((line, idx) => (
  <p key={idx}>{line}</p>
))}</div>}
    </div>
  );
};

const FAQAccordion = ({ faqs }) => (
  <div className="faq-accordion">
    {faqs.map((faq, idx) => (
      <FAQItem key={idx} {...faq} />
    ))}
  </div>
);

export default FAQAccordion;
